import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notifications-agreement',
  templateUrl: './notifications-agreement.component.html',
  styleUrls: ['./notifications-agreement.component.scss']
})
export class NotificationsAgreementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
